import { useState, useRef, useCallback, useMemo, useEffect, useLayoutEffect } from "react";

import { Switch } from "@mui/material";

import kutil from "@modules/kutil";

import { usePlcStore } from "@user/store/plc_store";
import { usePopup } from "@components/popup/popup_context";

interface Props {
};

export default function CvBlock(_props: Props) {
  const cvStatuses = usePlcStore(state => state.cvStatuses);
  const { setOption, setActions, onClose } = usePopup();

  useLayoutEffect(() => {
    setOption({
      title: "CV차단관리",
      maxWidth: "700px"
    });
    setActions([
      {
        id: "closePopup",
        label: "닫기",
        className: "basic outline",
        onClick: () => onClose(),
      }
    ]);
  }, []);

  async function setBlock(id: number, isBlock: boolean) {
    const msg = isBlock ? "차단하시겠습니까?" : "차단해제하시겠습니까?";
    if (await kutil.confirm(msg) == false) {
      return false;
    }

    try {
      const mode = isBlock ? "set" : "clear";
      const data = await kutil.sendPost("/api/work/cv_block.proc?mode=" + mode, {id}, {
      });

      const msg = isBlock ? "차단되었습니다." : "차단해제되었습니다.";
      await kutil.alert(msg);
    } catch(e) {
      console.log(e);
    }
  }

  const targets = [112, 151, 188, 403, 205, 212, 219, 226];
  return (
    <>
      <div className="popup-contents">
        <div className="table-wrap">
          <table>
            <colgroup>
              <col style={{ width: "33.3%" }} />
              <col style={{ width: "66.6%" }} />
            </colgroup>
            <tbody>
              {targets.map((id) => (
                <tr key={id}>
                  <th scope="row">#{id}</th>
                  <td>
                    <Switch
                      checked={cvStatuses.get(id)?.isBlock}
                      onChange={(_, checked) => {
                        setBlock(id, checked);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
